 
    <div id="formContent">
 <img src="assets/images/logos/km-logo.png"  class="img-fluid" style="width: 60%;"/>
        <form class="form">
            <input [(ngModel)]="username" type="text" id="username" class="form-control" name="username"
                placeholder="username">
            <input [(ngModel)]="password" type="password" id="password" class="form-control" name="login"
                placeholder="password">
                <div class="d-grid gap-2">
                    <input type="submit" class="btn btn-primary btn-block" value="Log In" style="margin-top:3px" (click)="onLogin()">
                  </div>
          
        </form>
    </div>
 